<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>Cancel Migration</template>
        <template v-slot:subheader> Migration {{ migration.id }} → {{ migration.target_team_name }} </template>

        <div class="text-sm text-slate-800">
            <strong>Are you sure you want to cancel this migration?</strong>
            <div class="mt-2">
                The migration will stop processing. Already-migrated contacts will remain in the target team.
            </div>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Go Back
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-cancel"
                    :loading="canceling"
                    type="button"
                    class="grow"
                    size="lg"
                    color="danger"
                >
                    Cancel Migration
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import { HTTP_INTERNAL_SERVER_ERROR } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';
import { adminTeamMigrationsClient } from '~/services';

const toasted = useToasted();

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const migration = defineModel('migration', {
    type: Object,
    required: true,
});

const canceling = ref(false);

const confirm = async () => {
    if (canceling.value) {
        return;
    }

    try {
        canceling.value = true;

        await adminTeamMigrationsClient.cancelMigration(migration.value.id);

        visible.value = false;
        migration.value.status = 'canceling';
    } catch (e) {
        console.error(e);
        if (e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
            toasted.global.platform_error();
            return;
        }

        toasted.error(e.response?.data?.message || 'Something went wrong.');
    } finally {
        canceling.value = false;
    }
};
</script>
